import Projects from "./Projects"
import ExperienceStories from "./ExperienceStories"

export default function Details({ stories, skills }) {
    return (
        <div className="details">
            <div className="fleft h-100 w-18">
                <Projects />
            </div>
            <div className="fright w-81">
                <ExperienceStories 
                    stories={ stories }
                    skills={ skills }
                />
            </div>
        </div>
    )
}